export default __webpack_public_path__ + "static/media/ARSMaquettePro-Regular.0693a210.woff";